/**
 * @flow
 */
'use strict';

export const santeParentCodes = [
{"code":"Arrière grand-mère"},
{"code":"Coté maternelle"},
{"code":"Cousin"},
{"code":"Cousine"},
{"code":"Cousine (m)"},
{"code":"Cousine (p)"},
{"code":"Frère"},
{"code":"Frère, mère"},
{"code":"Frère, père"},
{"code":"Frère/soeur"},
{"code":"G-p maternel"},
{"code":"Gand-tante (m)"},
{"code":"Grand oncle"},
{"code":"Grand-mère"},
{"code":"Grand-mère (m)"},
{"code":"Grand-mère (p)"},
{"code":"Grand-pere"},
{"code":"Grand-père (m)"},
{"code":"Grand-père (p)"},
{"code":"Grands parents"},
{"code":"Lien de parenté 3"},
{"code":"Maternelle"},
{"code":"Mère"},
{"code":"Mère ?"},
{"code":"Mère et père"},
{"code":"Mère/sœur"},
{"code":"Nièce"},
{"code":"Normale"},
{"code":"Oncle"},
{"code":"Oncle (m)"},
{"code":"Oncle (p)"},
{"code":"Oncles/tantes (p)"},
{"code":"Papa"},
{"code":"Parent"},
{"code":"Parents"},
{"code":"Paternelle"},
{"code":"Petite cousine"},
{"code":"Père"},
{"code":"Père (trauma)"},
{"code":"Père ?"},
{"code":"Père/mere"},
{"code":"Soeur + tante"},
{"code":"Sœur"},
{"code":"Tante"},
{"code":"Tante (m)"},
{"code":"Tante (p)"},
]
